import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styles from './SidebarRecommendedProductsWrapper.module.scss';
const SidebarRecommendedProductsWrapper = ({ children }) => {
    const { t } = useTranslation();
    return (_jsxs("div", Object.assign({ className: styles.wrapper }, { children: [_jsx("p", Object.assign({ className: styles.title }, { children: t('sidebar.recommendedProducts') })), children] })));
};
export default SidebarRecommendedProductsWrapper;
